import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCancel } from "@fortawesome/free-solid-svg-icons";

const MySwal = withReactContent(Swal2);

const LawsuitCheckList = (props) => {
  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [results, setResults] = useState([]);
  const [results2, setResults2] = useState([]);
  const [final_check, setFinalCheck] = useState("");
  const [finalChecker2, setFinalChecker2] = useState("");
  const [superNote, setSuperNote] = useState("");
  const [superNote2, setSuperNote2] = useState("");

  function replaceAll(str, find, replace) {
    return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
  }

  const fetchResults = async () => {
    var body = {};

    var url =
      props.client.type === "sankcja kredytu darmowego"
        ? "https://apidevkppp.ftpeople.pl/getCheckOptionsLawsuitSKD"
        : "https://apidevkppp.ftpeople.pl/getCheckOptionsLawsuit";

    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setQuestions(data);
        var arr = [];
        var arr2 = [];
        if (props.client.checklist) {
          data.map((el, index) => {
            var check = JSON.parse(
              props.client.checklist
                .replaceAll(/\\n/g, "\\n")
                .replaceAll(/\\'/g, "\\'")
                .replaceAll(/\\"/g, '\\"')
                .replaceAll(/\\&/g, "\\&")
                .replaceAll(/\\r/g, "\\r")
                .replaceAll(/\\t/g, "\\t")
                .replaceAll(/\\b/g, "\\b")
                .replaceAll(/\\f/g, "\\f")
                .replaceAll(/\n/g, "\\\\n")
                .replaceAll(/\r/g, "\\\\r")
                .replaceAll(/\t/g, "\\\\t")
            );

            if (check.filter((e) => e.question === el.question).length > 0) {
              var newR = {
                index: index,
                result: check.filter((e) => e.question === el.question)[0]
                  .result,
                note: check
                  .filter((e) => e.question === el.question)[0]
                  .note.toString()
                  .replaceAll('"', ""),
              };
              arr.push(newR);
            }

            try {
              if (props.client.checklist2) {
                var check2 = JSON.parse(
                  props.client.checklist2
                    .replaceAll(/\\n/g, "\\n")
                    .replaceAll(/\\'/g, "\\'")
                    .replaceAll(/\\"/g, '\\"')
                    .replaceAll(/\\&/g, "\\&")
                    .replaceAll(/\\r/g, "\\r")
                    .replaceAll(/\\t/g, "\\t")
                    .replaceAll(/\\b/g, "\\b")
                    .replaceAll(/\\f/g, "\\f")
                    .replaceAll(/\n/g, "\\\\n")
                    .replaceAll(/\r/g, "\\\\r")
                    .replaceAll(/\t/g, "\\\\t")
                );

                if (
                  check2.filter((e) => e.question === el.question).length > 0
                ) {
                  var newR = {
                    index: index,
                    result: check2.filter((e) => e.question === el.question)[0]
                      .result,
                    note: check2
                      .filter((e) => e.question === el.question)[0]
                      .note.replaceAll('"', ""),
                  };
                  arr2.push(newR);
                }
              }
            } catch (err) {}
          });
        }

        setResults(arr);
        setResults2(arr2);
        setFinalCheck(props.client.checklist3);
        setSuperNote(props.client.checklist4 ? props.client.checklist4 : "");
        setSuperNote2(props.client.checklist5 ? props.client.checklist5 : "");
        fetchFinal();
      })
      .catch((error) => {});
  };

  const fetchFinal = async () => {
    var body = {};

    var url = "https://apidevkppp.ftpeople.pl/getUsersSend3";

    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFinalChecker2(data[0].user);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchResults();
  };

  useEffect(() => {
    getData();
  }, []);

  const handleChangeAnswer = (res, id) => {
    var bool = false;
    if (results.length > 0) {
      results.map((el) => {
        if (+el.index === +id) {
          el.result = res;
          bool = true;
        }
      });
    }

    if (bool) {
      return;
    }
    results.push({ index: id, result: res, note: "" });
  };

  const handleChangeAnswer2 = (res, id) => {
    var bool = false;
    if (results2.length > 0) {
      results2.map((el) => {
        if (+el.index === +id) {
          el.result = res;
          bool = true;
        }
      });
    }

    if (bool) {
      return;
    }
    results2.push({ index: id, result: res, note: "" });
  };

  const handleChangeNote = (note, id) => {
    var bool = false;
    if (results.length > 0) {
      results.map((el) => {
        if (+el.index === +id) {
          el.note = note;
          bool = true;
        }
      });
    }

    if (bool) {
      return;
    }
    results.push({ index: id, result: "", note: note });
  };

  const handleChangeNote2 = (note, id) => {
    var bool = false;
    if (results.length > 0) {
      results2.map((el) => {
        if (+el.index === +id) {
          el.note = note;
          bool = true;
        }
      });
    }

    if (bool) {
      return;
    }
    results2.push({ index: id, result: "", note: note });
  };

  const save = async () => {
    var arr = [];
    questions.map((el, index) => {
      var newR = {
        question: el.question,
        result: results.filter((r) => +r.index === +index)[0]
          ? (
              results.filter((r) => +r.index === +index)[0].result
                ? results
                    .filter((r) => +r.index === +index)[0]
                    .result.toString()
                    .replaceAll('"', "")
                : ""
            )
            ? results.filter((r) => +r.index === +index)[0].result
              ? results
                  .filter((r) => +r.index === +index)[0]
                  .result.toString()
                  .replaceAll('"', "")
              : ""
            : false
          : "",
        note: results.filter((r) => +r.index === +index)[0]
          ? results.filter((r) => +r.index === +index)[0].note
            ? results
                .filter((r) => +r.index === +index)[0]
                .note.toString()
                .replaceAll("\n", "")
                .replaceAll('"', "")
            : ""
          : "",
      };
      arr.push(newR);
    });

    var body = {
      id: props.client.id,
      content: JSON.stringify(arr),
      superNote: superNote,
      superNote2: superNote2,
    };

    await fetch("https://apidevkppp.ftpeople.pl/addClientChecklist", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zapisano",
          text: "ankietę",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const save2 = async () => {
    setLoading(true);
    var arr = [];
    questions.map((el, index) => {
      var newR = {
        question: el.question,
        result: results.filter((r) => +r.index === +index)[0]
          ? results.filter((r) => +r.index === +index)[0].result
            ? results
                .filter((r) => +r.index === +index)[0]
                .result.toString()
                .replaceAll('"', "")
            : ""
            ? results.filter((r) => +r.index === +index)[0].result
              ? results
                  .filter((r) => +r.index === +index)[0]
                  .result.toString()
                  .replaceAll('"', "")
              : ""
            : false
          : false,
        note: results.filter((r) => +r.index === +index)[0]
          ? results.filter((r) => +r.index === +index)[0].note
            ? results
                .filter((r) => +r.index === +index)[0]
                .note.toString()
                .replaceAll("\n", "")
                .replaceAll('"', "")
            : ""
          : false,
      };
      arr.push(newR);
    });

    var body = {
      id: props.client.id,
      content: JSON.stringify(arr),
      superNote: superNote,
      superNote2: superNote2,
    };

    await fetch("https://apidevkppp.ftpeople.pl/addClientChecklistClose", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
        var templateParams = {
          to:
            props.users.filter((el) => el.name === props.client.praw_spr_pozew)
              .length > 0
              ? props.users.filter(
                  (el) => el.name === props.client.praw_spr_pozew
                )[0].mail
              : "m.bialas@kppp.pl",
          reply_to: "",
          content: `W sprawie o ID: ${
            props.client.id_old
          } (${props.client.petitioner.replaceAll(
            "  ",
            ""
          )}) zakończono checklistę do pozwu. Proszę o sprawdzenie.`,
          subject: `W sprawie o ID: ${props.client.id_old} zakończono checklistę do pozwu. Proszę o sprawdzenie.`,
          user_name: props.client.praw_pozew,
        };

        emailjs.send("KPPP", "template_h43760d", templateParams).then(
          function (response) {
            MySwal.fire({
              icon: "success",
              title: "Zapisano",
              text: "ankietę",
            }).then(async (result) => {
              props.close();
            });
          },
          function (error) {
            MySwal.fire({
              icon: "error",
              title: "Błąd",
              text: "nie wysłano wiadomości e-mail. Ponów operację!",
            }).then(async (result) => {
              props.close();
            });
          }
        );
      })
      .catch((error) => {});
  };

  const save3 = async () => {
    var arr = [];
    questions.map((el, index) => {
      var newR = {
        question: el.question,
        result: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].result
            ? results2
                .filter((r) => +r.index === +index)[0]
                .result.toString()
                .replaceAll('"', "")
            : ""
            ? results2.filter((r) => +r.index === +index)[0].result
              ? results2
                  .filter((r) => +r.index === +index)[0]
                  .result.toString()
                  .replaceAll('"', "")
              : ""
            : false
          : false,
        note: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].note
            ? results2
                .filter((r) => +r.index === +index)[0]
                .note.toString()
                .replaceAll("\n", "")
                .replaceAll('"', "")
            : ""
          : false,
      };
      arr.push(newR);
    });

    var body = {
      id: props.client.id,
      content: JSON.stringify(arr),
      superNote: superNote,
      superNote2: superNote2,
    };

    await fetch("https://apidevkppp.ftpeople.pl/addClientChecklist2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zapisano",
          text: "sprawdzenie",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const save5 = async () => {
    var arr = [];
    questions.map((el, index) => {
      var newR = {
        question: el.question,
        result: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].result
            ? results2
                .filter((r) => +r.index === +index)[0]
                .result.toString()
                .replaceAll('"', "")
            : ""
            ? results2.filter((r) => +r.index === +index)[0].result
              ? results2
                  .filter((r) => +r.index === +index)[0]
                  .result.toString()
                  .replaceAll('"', "")
              : ""
            : false
          : false,
        note: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].note
            ? results2
                .filter((r) => +r.index === +index)[0]
                .note.toString()
                .replaceAll("\n", "")
                .replaceAll('"', "")
            : ""
          : false,
      };
      arr.push(newR);
    });

    var body = {
      id: props.client.id,
      content: final_check,
    };

    await fetch("https://apidevkppp.ftpeople.pl/addClientChecklist3", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zapisano",
          text: "sprawdzenie",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const save4 = async () => {
    var arr = [];
    questions.map((el, index) => {
      var newR = {
        question: el.question,
        result: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].result
            ? results2
                .filter((r) => +r.index === +index)[0]
                .result.toString()
                .replaceAll('"', "")
            : ""
            ? results2.filter((r) => +r.index === +index)[0].result
              ? results2
                  .filter((r) => +r.index === +index)[0]
                  .result.toString()
                  .replaceAll('"', "")
              : ""
            : false
          : "",
        note: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].note
            ? results2
                .filter((r) => +r.index === +index)[0]
                .note.toString()
                .replaceAll("\n", "")
                .replaceAll('"', "")
            : ""
          : "",
      };
      arr.push(newR);
    });

    var body = {
      id: props.client.id,
      content: JSON.stringify(arr),
      superNote: superNote,
      superNote2: superNote2,
    };

    await fetch("https://apidevkppp.ftpeople.pl/addClientChecklist2Close", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zapisano",
          text: "sprawdzenie",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const save6 = async () => {
    var arr = [];
    questions.map((el, index) => {
      var newR = {
        question: el.question,
        result: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].result
            ? results2
                .filter((r) => +r.index === +index)[0]
                .result.toString()
                .replaceAll('"', "")
            : ""
            ? results2.filter((r) => +r.index === +index)[0].result
              ? results2
                  .filter((r) => +r.index === +index)[0]
                  .result.toString()
                  .replaceAll('"', "")
              : ""
            : false
          : "",
        note: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].note
            ? results2
                .filter((r) => +r.index === +index)[0]
                .note.toString()
                .replaceAll("\n", "")
                .replaceAll('"', "")
            : ""
          : "",
      };
      arr.push(newR);
    });

    var body = {
      id: props.client.id,
      content: final_check,
    };

    await fetch("https://apidevkppp.ftpeople.pl/addClientChecklist3Close", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zapisano",
          text: "sprawdzenie",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const open = async () => {
    var body = {
      id: props.client.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/openClientChecklistClose", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Otwarto",
          text: "ankietę",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const open2 = async () => {
    var body = {
      id: props.client.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/openClientChecklistClose2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Otwarto",
          text: "sprawdzenie",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const open3 = async () => {
    var body = {
      id: props.client.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/openClientChecklistClose3", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Otwarto",
          text: "sprawdzenie",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const checkTable = (
    <>
      <table className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Do weryfikacji</th>
          <th>Sporządzający pozew</th>
          <th>Sprawdzający pozew - czy dane są prawidłowe</th>
        </tr>
        {questions.map((el, index) => (
          <>
            <tr id={""} key={index}>
              <td>{index + 1}</td>
              <td style={{ fontSize: "1vw" }}>{el.question}</td>
              <td>
                {el.type === "text" ? (
                  <>
                    <input
                      style={{ boxSizing: "border-box" }}
                      type="text"
                      disabled={
                        !props.client.checklist_close ||
                        props.client.checklist_close === "0"
                          ? props.client.praw_pozew === props.user.name ||
                            props.user.superAdmin === "1"
                            ? false
                            : true
                          : true
                      }
                      value={
                        results.filter((r) => +r.index === +index)[0]
                          ? results.filter((r) => +r.index === +index)[0].result
                          : ""
                      }
                      onChange={(e) => {
                        handleChangeAnswer(e.target.value, index);
                      }}
                    />
                  </>
                ) : (
                  ""
                )}
                {el.type === "select" ? (
                  <>
                    <select
                      style={{ boxSizing: "border-box" }}
                      type="text"
                      disabled={
                        !props.client.checklist_close ||
                        props.client.checklist_close === "0"
                          ? props.client.praw_pozew === props.user.name ||
                            props.user.superAdmin === "1"
                            ? false
                            : true
                          : true
                      }
                      value={
                        results.filter((r) => +r.index === +index)[0]
                          ? results.filter((r) => +r.index === +index)[0].result
                          : ""
                      }
                      onChange={(e) => {
                        handleChangeAnswer(e.target.value, index);
                      }}
                    >
                      {!results.filter((r) => +r.index === +index)[0] ? (
                        <option key={0} value={0}>
                          Wybierz...
                        </option>
                      ) : (
                        ""
                      )}
                      {el.options.split(",").map((e) => (
                        <>
                          <option key={e} value={e}>
                            {e}
                          </option>
                        </>
                      ))}
                    </select>
                  </>
                ) : (
                  ""
                )}
                {el.type === "checkbox" ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "5px",
                          padding: "5px",
                          alignItems: "center",
                          fontSize: "1.5vw",
                          color: "green",
                          fontWeight: "900",
                        }}
                      >
                        <FontAwesomeIcon icon={faCheck} />
                        <input
                          style={{
                            boxSizing: "border-box",
                            height: "2vh",
                            width: "15px",
                          }}
                          disabled={
                            !props.client.checklist_close ||
                            props.client.checklist_close === "0"
                              ? props.client.praw_pozew === props.user.name ||
                                props.user.superAdmin === "1"
                                ? false
                                : true
                              : true
                          }
                          type="checkbox"
                          checked={
                            results.filter((r) => +r.index === +index)[0]
                              ? results.filter((r) => +r.index === +index)[0]
                                  .result
                              : false
                          }
                          onChange={(e) => {
                            handleChangeAnswer(e.target.checked, index);
                          }}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </td>
              <td>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      padding: "5px",
                      alignItems: "center",
                      fontSize: "1.5vw",
                      color: "green",
                      fontWeight: "900",
                    }}
                  >
                    <FontAwesomeIcon icon={faCheck} />
                    <input
                      style={{
                        boxSizing: "border-box",
                        height: "2vh",
                        width: "15px",
                      }}
                      disabled={
                        props.client.checklist_close === "0" ||
                        !props.client.checklist_close
                          ? true
                          : props.client.checklist_close === "1"
                          ? props.user.name === props.client.praw_spr_pozew ||
                            props.user.superAdmin === "1"
                            ? false
                            : true
                          : props.client.checklist_close === "2"
                          ? true
                          : props.client.checklist_close === "3"
                          ? true
                          : false
                      }
                      type="checkbox"
                      checked={
                        results2.filter((r) => +r.index === +index)[0]
                          ? results2.filter((r) => +r.index === +index)[0]
                              .result
                            ? true
                            : false
                          : false
                      }
                      onChange={(e) => {
                        handleChangeAnswer2(true, index);
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      padding: "5px",
                      alignItems: "center",
                      fontSize: "1.5vw",
                      color: "red",
                      fontWeight: "900",
                    }}
                  >
                    <FontAwesomeIcon icon={faCancel} />
                    <input
                      style={{
                        boxSizing: "border-box",
                        height: "2vh",
                        width: "15px",
                      }}
                      disabled={
                        props.client.checklist_close === "0" ||
                        !props.client.checklist_close
                          ? true
                          : props.client.checklist_close === "1"
                          ? props.user.name === props.client.praw_spr_pozew ||
                            props.user.superAdmin === "1"
                            ? false
                            : true
                          : props.client.checklist_close === "2"
                          ? true
                          : props.client.checklist_close === "3"
                          ? true
                          : false
                      }
                      type="checkbox"
                      checked={
                        results2.filter((r) => +r.index === +index)[0]
                          ? !results2.filter((r) => +r.index === +index)[0]
                              .result
                            ? true
                            : false
                          : false
                      }
                      onChange={(e) => {
                        handleChangeAnswer2(false, index);
                      }}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ fontSize: "1vw" }}>Notatka</td>
              <td colSpan="2" style={{ padding: "10px" }}>
                {" "}
                <textarea
                  style={{
                    height: "10vh",
                    width: "100%",
                    border: "none",
                    boxShadow: "none",
                    margin: "0",
                  }}
                  className="textAreaNote"
                  disabled={
                    !props.client.checklist_close ||
                    props.client.checklist_close === "0"
                      ? props.client.praw_pozew === props.user.name ||
                        props.user.superAdmin === "1"
                        ? false
                        : true
                      : true
                  }
                  value={
                    results.filter((r) => +r.index === +index)[0]
                      ? results.filter((r) => +r.index === +index)[0].note
                      : ""
                  }
                  onChange={(e) => {
                    handleChangeNote(e.target.value, index);
                  }}
                />
              </td>
              <td style={{ padding: "10px" }}>
                {" "}
                <textarea
                  style={{
                    height: "10vh",
                    width: "100%",
                    border: "none",
                    boxShadow: "none",
                    margin: "0",
                  }}
                  className="textAreaNote"
                  disabled={
                    props.client.checklist_close === "0" ||
                    !props.client.checklist_close
                      ? true
                      : props.client.checklist_close === "1"
                      ? props.user.name === props.client.praw_spr_pozew ||
                        props.user.superAdmin === "1"
                        ? false
                        : true
                      : props.client.checklist_close === "2"
                      ? true
                      : props.client.checklist_close === "3"
                      ? true
                      : false
                  }
                  value={
                    results2.filter((r) => +r.index === +index)[0]
                      ? results2.filter((r) => +r.index === +index)[0].note
                      : ""
                  }
                  onChange={(e) => {
                    handleChangeNote2(e.target.value, index);
                  }}
                />
              </td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  return (
    <div
      style={{
        width: "100%",
        position: "relative",
        right: "auto",
        top: "auto",
        boxSizing: "border-box",
        boxShadow: "none",
      }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <p style={{ fontWeight: "900" }}>ANKIETA DO POZWU</p>
          {checkTable}

          <>
            <div className="inputBox">
              <div
                className="inputCol_1"
                style={{ width: "100%", minWidth: "100%" }}
              >
                <label>Notatka - sporządzający pozew</label>
                <textarea
                  style={{ height: "10vh", width: "100%", marginTop: "1vh" }}
                  className="textAreaNote"
                  disabled={
                    props.client.checklist_close !== "2" ||
                    props.client.checklist_close !== "1"
                      ? props.user.name === props.client.praw_pozew ||
                        props.user.superAdmin === "1"
                        ? false
                        : true
                      : true
                  }
                  value={superNote}
                  onChange={(e) => {
                    setSuperNote(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="inputBox">
              <div
                className="inputCol_1"
                style={{ width: "100%", minWidth: "100%" }}
              >
                <label>Notatka - sprawdzający</label>
                <textarea
                  style={{ height: "10vh", width: "100%", marginTop: "1vh" }}
                  className="textAreaNote"
                  disabled={
                    props.client.checklist_close !== "2" ||
                    props.client.checklist_close !== "1"
                      ? props.user.name === props.client.praw_spr_pozew ||
                        props.user.superAdmin === "1"
                        ? false
                        : true
                      : true
                  }
                  value={superNote2}
                  onChange={(e) => {
                    setSuperNote2(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="inputBox">
              <div
                className="inputCol_1"
                style={{ width: "100%", minWidth: "100%" }}
              >
                <label>Notatka - finalne sprawdzenie</label>
                <textarea
                  style={{ height: "10vh", width: "100%", marginTop: "1vh" }}
                  className="textAreaNote"
                  disabled={
                    props.client.checklist_close === "2"
                      ? props.finalChecker === props.user.name ||
                        finalChecker2 === props.user.name
                        ? false
                        : true
                      : true
                  }
                  value={final_check}
                  onChange={(e) => {
                    setFinalCheck(e.target.value);
                  }}
                />
              </div>
            </div>
          </>

          <div className="saveBoxAP" style={{ display: "flex", gap: "10px" }}>
            {props.client.checklist_close === "0" ||
            !props.client.checklist_close ? (
              props.client.praw_pozew === props.user.name ||
              props.user.superAdmin === "1" ? (
                <>
                  <button className="paymentMenuButton" onClick={save}>
                    {"zapisz ankietę"}
                  </button>
                  <button className="paymentMenuButton" onClick={save2}>
                    {"zapisz i zamknij ankietę"}
                  </button>
                </>
              ) : (
                ""
              )
            ) : (
              ""
            )}

            {props.client.checklist_close === "1" ? (
              props.user.name === props.client.praw_spr_pozew ||
              props.user.superAdmin === "1" ? (
                <>
                  <button className="paymentMenuButton" onClick={save3}>
                    {"zapisz sprawdzenie"}
                  </button>
                  <button className="paymentMenuButton" onClick={save4}>
                    {"zapisz i zamknij sprawdzenie"}
                  </button>
                </>
              ) : (
                ""
              )
            ) : (
              ""
            )}

            {props.client.checklist_close === "2" ? (
              props.user.name === props.finalChecker ||
              props.user.superAdmin === "1" ? (
                <>
                  <button className="paymentMenuButton" onClick={save5}>
                    {"zapisz finalne sprawdzenie"}
                  </button>
                  <button className="paymentMenuButton" onClick={save6}>
                    {"zapisz i zamknij finalne sprawdzenie"}
                  </button>
                </>
              ) : (
                ""
              )
            ) : (
              ""
            )}

            {(props.user.superAdmin === "1" ||
              props.user.name === props.client.praw_spr_pozew) &&
            props.client.checklist_close === "1" ? (
              <>
                <button className="paymentMenuButton" onClick={open}>
                  {"otwórz ankietę użytkownika"}
                </button>
              </>
            ) : (
              ""
            )}
            {props.user.superAdmin === "1" &&
            props.client.checklist_close === "2" ? (
              <>
                <button className="paymentMenuButton" onClick={open2}>
                  {"otwórz sprawdzenie użytkownika"}
                </button>
              </>
            ) : (
              ""
            )}

            {props.user.superAdmin === "1" &&
            props.client.checklist_close === "3" ? (
              <>
                <button className="paymentMenuButton" onClick={open3}>
                  {"otwórz finalne sprawdzenie użytkownika"}
                </button>
              </>
            ) : (
              ""
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default LawsuitCheckList;
